export const educationData = [
    {
        id: 1,
        institution: 'National Institute Of Technology , Durgapur',
        course: 'Electrical Engineering',
        startYear: 'Aug 2019',
        endYear: 'Present',
        marks:"cgpa: 8.7"
    },
    {
        id: 2,
        institution: "Saint Joseph's School, Bhaktinagar",
        course: 'Class 12',
        startYear: '2017',
        endYear: '2019',
        marks:"percentage: 91%"
    },
    {
        id: 3,
        institution: "Saint Joseph's School, Bhaktinagar",
        course: 'Class 10',
        startYear: '2017',
        endYear: '2004',
        marks:"percentage: 93.4%"
    },
]